import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./pages/home/home.component";
import { BenefitComponent } from "./pages/benefit/benefit.component";
import { FaqComponent } from "./pages/faq/faq.component";
import { BlogComponent } from "./pages/blog/blog.component";
import { BlogExportComponent } from "./pages/blog/blog-export/blog-export.component";
import { BlogVideoFormatComponent } from "./pages/blog/blog-video-format/blog-video-format.component";
import { BlogReadDirectoryComponent } from "./pages/blog/blog-read-directory/blog-read-directory.component";
import { PrivacyComponent } from "./pages/privacy/privacy.component";
import { ImprintComponent } from "./pages/imprint/imprint.component";
import { FunctionsComponent } from "./pages/functions/functions.component";
import { ContactComponent } from "./pages/contact/contact.component";
import { FunctionArchiveComponent } from "./pages/function-archive/function-archive.component";
import { TrainingComponent } from "./pages/training/training.component";
import { DownloadComponent } from "./pages/download/download.component";
import { UtilityFilmDefinitionComponent } from "./pages/utility-film-definition/utility-film-definition.component";
import { ReasonsComponent } from "./pages/reasons/reasons.component";
import { ErrorComponent } from "./error/error/error.component";
import { InvalidDownloadComponent } from "./error/invalid-download/invalid-download.component";
import { ServerErrorComponent } from "./error/server-error/server-error.component";
import { VideoComponent } from "./pages/video/video.component";
import { LearningComponent } from "./pages/promotion/learning/learning.component";
import { ClipNumberComponent } from "./pages/blog/clip-number/clip-number.component";
import { UsingMetadataComponent } from "./pages/blog/using-metadata/using-metadata.component";
import { UsingSourcesComponent } from "./pages/blog/using-sources/using-sources.component";
import { ImageLibraryComponent } from "./pages/blog/image-library/image-library.component";
import { BlogBroseComponent } from "./pages/blog/blog-brose/blog-brose.component";
import { BlogSwitchLangComponent } from "./pages/blog/blog-switch-lang/blog-switch-lang.component";
import { BlogVersioningComponent } from "./pages/blog/blog-versioning/blog-versioning.component";
import { BlogImportComponent } from "./pages/blog/blog-import/blog-import.component";
import { BlogFramenavigationComponent } from "./pages/blog/blog-framenavigation/blog-framenavigation.component";
import { BlogScriptactionComponent } from "./pages/blog/blog-scriptaction/blog-scriptaction.component";
import { BlogVersion23Component } from "./pages/blog/blog-version23/blog-version23.component";
import { BlogV240Component } from "./pages/blog/blog-v240/blog-v240.component";
import { WebinarComponent } from "./pages/webinar/webinar.component";
import { AppointmentComponent } from "./pages/appointment/appointment.component";
import { BlogV250Component } from "./pages/blog/blog-v250/blog-v250.component";
import { BlogV260Component } from "./pages/blog/blog-v260/blog-v260.component";

const routes: Routes = [
  { path: "home", component: HomeComponent },
  {
    path: "utility-film-definition",
    component: UtilityFilmDefinitionComponent,
  },
  { path: "reasons", component: ReasonsComponent },
  { path: "benefit", component: BenefitComponent },
  { path: "functions", component: FunctionsComponent },
  { path: "function-archive", component: FunctionArchiveComponent },
  { path: "faq", component: FaqComponent },
  { path: "training", component: TrainingComponent },
  { path: "blog", component: BlogComponent },
  { path: "blog-export", component: BlogExportComponent },
  { path: "blog-videoformat", component: BlogVideoFormatComponent },
  { path: "blog-readdirectory", component: BlogReadDirectoryComponent },
  { path: "blog-clipnumber", component: ClipNumberComponent },
  { path: "blog-using-metadata", component: UsingMetadataComponent },
  { path: "blog-sources", component: UsingSourcesComponent },
  { path: "blog-image-library", component: ImageLibraryComponent },
  { path: "blog-brose", component: BlogBroseComponent },
  { path: "blog-versioning", component: BlogVersioningComponent },
  { path: "blog-import", component: BlogImportComponent },
  { path: "blog-framenavigation", component: BlogFramenavigationComponent },
  { path: "blog-scriptaction", component: BlogScriptactionComponent },
  { path: "blog-version23", component: BlogVersion23Component },
  { path: "blog-version24", component: BlogV240Component },
  { path: "blog-version25", component: BlogV250Component },
  { path: "blog-version26", component: BlogV260Component },
  { path: "support/switch-lang", component: BlogSwitchLangComponent },
  { path: "download", component: DownloadComponent },
  { path: "contact", component: ContactComponent },
  { path: "webinar", component: WebinarComponent },
  { path: "appointment", component: AppointmentComponent },
  { path: "privacy", component: PrivacyComponent },
  { path: "imprint", component: ImprintComponent },
  { path: "video", component: VideoComponent },
  { path: "error", component: ErrorComponent },
  { path: "error/invaliddownload", component: InvalidDownloadComponent },
  { path: "error/servererror", component: ServerErrorComponent },
  { path: "promotion/learning", component: LearningComponent },
  { path: "", component: HomeComponent },
  { path: "**", component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
